export const TRANSLATIONS = {
    EN: {
        USER_ACCOUNT: {
            PHOTO: 'Profile picture',
            MY_ACCOUNT: 'My account',
            INVOICES: 'My Invoices',
            PERSONAL_INFORMATION: 'User account',
            PERSONAL_DATA: 'Personal information',
            CONTACT_DETAILS: 'Contact details',
            PASSWORD: 'Password',
            CONFIRM_PASSWORD: 'Confirm password',
            CONFIRM_NEW_PASSWORD: 'Confirm new password',
            CURRENT_PASSWORD: 'Current password',
            REFERRAL_PAGE: 'Referral',
            NEW_PASSWORD: 'New password',
            SHOW_INVOICES_FOR: 'Show invoices for',
            REFERENCE: 'Reference',
            DOWNLOAD_SELECTION: 'Download selection',
            NO_INVOICES: 'No invoices available',
            ORGANIZATIONAL_RIGHTS: 'Organizational rights',
            NO_MEMBERS: 'No members',
            SHOW_PERMISSIONS_FOR: 'Show permissions for:',
            EXISTING_USERS: 'Existing users',
            SELECT_ORGANIZATION: 'Select a organization',
            ADD_USER: 'Add user',
            EMPLOYEES: 'Employees',
            ADD_EMPLOYEE: 'Add employee',
            UPDATE_EMPLOYEE: 'Update employee',
            NO_EMPLOYEE: 'No employees were found',
            ADD_CONTACT: 'Add contact',
            SUBSCRIPTIONS: 'Subscriptions',
            SHOW_SUBSCRIPTIONS_FOR: 'Show subscriptions for',
            PAYOUT_DETAILS: 'Payout details',
            PROCESS_LABEL: {
                LABEL: 'Process labels',
                CONFIRM_DELETE: 'Are you sure you want to delete this process label?',
                MODAL: {
                    ADD: 'Add process label',
                    UPDATE: 'Update process label',
                    NAME: 'Name',
                    COLOR: 'Color',
                    ICON: 'Icon',
                },
            },
        },
    },
    NL: {
        USER_ACCOUNT: {
            PHOTO: 'Profielfoto',
            MY_ACCOUNT: 'Mijn Account',
            INVOICES: 'Mijn facturen',
            PERSONAL_INFORMATION: 'Gebruikersaccountgegevens',
            PERSONAL_DATA: 'Persoonsgegevens',
            CONTACT_DETAILS: 'Contactgegevens',
            PASSWORD: 'Wachtwoord',
            CONFIRM_PASSWORD: 'Bevestig wachtwoord',
            CONFIRM_NEW_PASSWORD: 'Bevestig nieuw wachtwoord',
            CURRENT_PASSWORD: 'Huidig wachtwoord',
            REFERRAL_PAGE: 'Referral',
            NEW_PASSWORD: 'Nieuw wachtwoord',
            SHOW_INVOICES_FOR: 'Toon facturen voor',
            REFERENCE: 'Referentie',
            DOWNLOAD_SELECTION: 'Selectie downloaden',
            NO_INVOICES: 'Geen facturen beschikbaar',
            ORGANIZATIONAL_RIGHTS: 'Organisatierechten',
            NO_MEMBERS: 'No members',
            SHOW_PERMISSIONS_FOR: 'Toon rechten voor:',
            EXISTING_USERS: 'Bestaande gebruikers',
            SELECT_ORGANIZATION: 'Selecteer een organisatie',
            ADD_USER: 'Gebruiker toevoegen',
            EMPLOYEES: 'Werknemers',
            ADD_EMPLOYEE: 'Add Werknemer',
            UPDATE_EMPLOYEE: 'Werknemer bijwerken',
            NO_EMPLOYEE: 'Er zijn geen medewerkers opgericht',
            ADD_CONTACT: 'Add contact',
            SUBSCRIPTIONS: 'Abonnementen',
            SHOW_SUBSCRIPTIONS_FOR: 'Toon abonnementen voor',
            PAYOUT_DETAILS: 'Uitbetaling gegevens',
            PROCESS_LABEL: {
                LABEL: 'Proces labels',
                CONFIRM_DELETE: 'Weet u zeker dat u dit proceslabel wilt verwijderen?',
                MODAL: {
                    ADD: 'Proces label toevoegen',
                    UPDATE: 'Proces label updaten',
                    NAME: 'Naam',
                    COLOR: 'Kleur',
                    ICON: 'Icon',
                },
            },
        },
    },
};
